import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AddDocumentDialogContainerComponent } from '../components/add-document-dialog-container/add-document-dialog-container.component';
import { AddDocumentsDialogOptions } from '../models/add-document-dialog-options.model';

@Injectable({
  providedIn: 'root',
})
export class AddDocumentDialogService {
  constructor(private dialog: MatDialog) {}

  upload<T>(options?: Partial<AddDocumentsDialogOptions>): Observable<T | boolean> {
    const dialogOptions: MatDialogConfig = {
      width: '500px',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      position: { top: '0', right: '0' },
      disableClose: false,
      panelClass:
        options.currentThemeMode === 'dark'
          ? ['dark-theme', 'add-document-dialog']
          : ['light-theme', 'add-document-dialog'],
      autoFocus: false,
      data: options,
    };

    return this.dialog.open(AddDocumentDialogContainerComponent, dialogOptions).beforeClosed();
  }
}
